export default function BookingPeriodsEntriesFactory(BookingPeriodsService) {
    var fn = this;

    fn.updatePrices = (bookingPeriods) => {
        const bookingPeriodsPrice = bpSum(bookingPeriods);

        const entriesPrice = eSum(bookingPeriods);

        return {
            bookingPeriodsPrice: bookingPeriodsPrice,
            entriesPrice: entriesPrice,
            totalPrice: bookingPeriodsPrice + entriesPrice,
        };
    };

    fn.findUniqueEntries = (bookingPeriods) => {
        let uniqueEntries = [];

        bookingPeriods.forEach((bp) => {
            bp.bookingPeriodEntries.forEach((entry) => {
                if (entry.amount > 0) {
                    var foundExisting = false;

                    uniqueEntries.forEach((uEntry) => {
                        if (uEntry.resourceEntryId == entry.resourceEntryId) {
                            foundExisting = true;

                            //* NOTE THAT WE ARE CHANGING THE OBJECT COUNT (INSIDE THIS SCOPE ONLY!" ")
                            uEntry.amount = entry.amount + uEntry.amount;
                        }
                    });

                    if (!foundExisting) {
                        uniqueEntries.push(angular.copy(entry));
                    }
                }
            });
        });
        return uniqueEntries;
    };

    const bpSum = (bookingPeriods) => {
        // var total = 0; // reset and recalculate total price
        let total = 0;
        bookingPeriods.forEach((bp) => {
            total += bp.price;
        });

        return total;
    };

    const eSum = (bookingPeriods) => {
        // var total = 0; // reset and recalculate total price
        let total = 0;

        bookingPeriods.forEach((bp) => {
            bp.bookingPeriodEntries.forEach((entry) => {
                total += entry.price * entry.amount;
            });
        });

        return total;
    };

    return fn;
}
